import getSymbolFromCurrency from "currency-symbol-map";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  Renderer2,
  SimpleChanges,
  input,
} from "@angular/core";
import _ from "lodash";
import * as moment from "moment";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { Router } from "@angular/router";

import { ContinueStayComponent } from "./continue-stay/continue-stay.component";
import { HouseStatusService } from "@root/router/deprecated_and_do_not_use-house/house-status/house-status.service";
import { ModalService } from "@root/router/index/modal.service";
import { PlatformInfo, PlatformType } from "@root/config";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { StoreService } from "@root/shared/service/store.service";
import { HouseOrderDetailComponent } from "../house-order-detail.component";
import { AppService } from "@root/app.service";
import { NzDrawerRef, NzDrawerService } from "ng-zorro-antd/drawer";
import { MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";
import { HouseOrderboxComponent } from "../../calendar/house-orderbox/house-orderbox.component";

@Component({
  selector: "host-house-order-basic",
  templateUrl: "./house-order-basic.component.html",
  styleUrls: ["./house-order-basic.component.scss"],
})
export class HouseOrderBasicComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() orderDetail;

  get orderStatus() {
    return this.orderDetail?.out_status;
  }

  get isConflict() {
    return !!(this.orderDetail && this.orderDetail.conflict_label.is_conflict);
  }

  // 是否多房订单。即一个订单含有多个入住单
  get isMultiHouseReservation() {
    return this.orderDetail?.reservation_order?.reservation_count > 1;
  }

  /** @fixme @todo 作用未知，暂时保留 */
  get statusMap() {
    return _.groupBy(this.orderDetail?.housing_status, "available");
  }

  get isInternational() {
    return this.app.app.international;
  }

  get pageInitialized() {
    return !!this.orderDetail;
  }

  //#endregion
  constructor(
    private msg: NzMessageService,
    private modal: NzModalService,
    private router: Router,
    private render: Renderer2,
    private orderService: OrderV2Service,
    private calendarService: MultiHouseCalendarService,
    private houseStatusService: HouseStatusService,
    private globalModalService: ModalService,
    private t: TranslateService,
    private storeService: StoreService,
    private app: AppService,
    @Optional() private drawerRef: NzDrawerRef,
  ) {}
  readonly Platform: typeof PlatformType = PlatformType;
  @Input() pageType: "sidebar" | "modal" = "sidebar";
  @Input() loading = false;
  @Output() refreshModal = new EventEmitter();
  @Output() changeOrder = new EventEmitter();
  @Output() onToGuestPage = new EventEmitter();
  @Output() onCreateHourOrder = new EventEmitter<any>();

  multiHouseResCollapsed = true;

  isEditingBasicInfo = false;
  isEditingFee = false;
  isEditingLockPwd = false;

  acceptLoading = false;
  refuseLoading = false;
  hasHouseStatus = ["completed", "wait_stay", "staying"];
  cancelHouseStatus = ["cancelled", "denied", "timeout"];
  reservationList = [];

  // 用于复制的订单详情结构
  resvDetailText;

  hourCalendarCollapsed = true;

  get isEditing() {
    return this.isEditingBasicInfo || this.isEditingFee || this.isEditingLockPwd;
  }

  ngOnInit() {
    console.log("basic init");
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("change: ", changes);
    if (changes["orderDetail"] && changes["orderDetail"].currentValue) {
      if (this.isMultiHouseReservation) {
        this.fetchMultHouseReservations();
      }
      this.loading = false;
      this.resvDetailText = this.formatResvDetailForCopy();
      console.log("this.reservationList: ", this.reservationList);
    }
  }

  ngAfterViewInit(): void {
    const wrapper = document.getElementById("compact-fix-tab-style");
    wrapper.style.display = "block";
    setTimeout(() => {
      wrapper.style.display = "flex";
    }, 500);
  }

  ngOnDestroy() {}

  fetchMultHouseReservations() {
    this.orderService.getReservations({ code: _.get(this.orderDetail, "reservation_order.code") }).subscribe((res) => {
      this.reservationList = res?.data?.list?.filter((item) => item.code !== this.orderDetail.code);
    });
  }

  /** @deprecated */
  toHouseType() {
    this.modal.closeAll();
    this.router.navigate(["/app/properties/room-types"], {
      queryParams: {
        subTab: 2,
        id: _.get(this.orderDetail, "house_type_id"),
      },
    });
  }

  checkReservation(code) {
    this.calendarService.selectReservation(code);
  }

  formatResvDetailForCopy() {
    const d = this.orderDetail;
    const symbol = getSymbolFromCurrency(d.currency_type);
    return `
Code: ${d.code}
Guest: ${d.client?.name || "-"}
Phone: ${d.client?.phone || "-"}
Channel: ${this.t.t("word.channel_" + d.thirdparty_type)}
Number of guests: ${d.number_of_guests}
Property: ${d.house_title || "-"}
Original room: ${d.origin_house_title || "-"}
Check-in: ${d.check_in} ${d.check_in_time || ""}
Check-out: ${d.check_out} ${d.check_out_time || ""}
Status: ${this.t.t("order_status." + d.out_status)}
Tags:  ${d.reservation_tag?.map((t) => t.tag_name)?.join(",") || "-"}
Remarks: ${d.remark || "-"}
Rates:  ${symbol}${d.amount_items?.house_fee?.amount || 0}
Commission: ${symbol}${d.amount_items?.commission?.amount || 0}
Net rate: ${symbol}${d.amount_items?.net_house_fee?.amount || 0}
Currency:  ${d.currency_type}
Booking time: ${d.booked_time}
    `;
  }

  toOrderbox() {
    this.houseStatusService.getWidgetCount().subscribe((res) => {
      const count = _.get(res, "data.box_count");
      const modal = this.modal.create({
        nzTitle: this.t.t("house.orderbox_task_count", {
          count,
        }),
        nzWidth: 860,
        nzContent: HouseOrderboxComponent,
        nzFooter: null,
        nzComponentParams: {
          tabType: this.orderDetail?.is_history ? "history" : "active",
        },
      });
      modal.afterClose.subscribe(() => {
        // this.refresh = true;
        this.refreshModal.emit(true);
      });
    });
  }

  @WritePermissionGurd("reservation_list")
  onCloseRoomStatus() {
    const temEnd = this.orderDetail.check_out;
    const end = moment(temEnd).subtract(1, "days").format("YYYY-MM-DD");
    const params = {
      begin: this.orderDetail.check_in,
      end: end,
      id: this.orderDetail.house_id,
      available: 0,
      daily_price_list: "[]",
    };
    this.houseStatusService.editHouseDailyPrice(params).subscribe((res: HttpRsp) => {
      if (res.error_code === 0) {
        // this.refresh = true;
        this.refreshModal.emit(true);
      }
    });
  }

  // 编辑订单信息
  @WritePermissionGurd("reservation_list")
  editOrderInfo() {
    if (this.checkIsEditing()) {
      return;
    }
    this.isEditingBasicInfo = true;
  }

  cancelEditOrderInfo() {
    this.isEditingBasicInfo = false;
  }

  onModifyBasicInfo() {
    this.isEditingBasicInfo = false;
    this.refreshModal.emit(true);
    this.calendarService.refresh();
  }

  onModifyFee() {
    this.isEditingFee = false;
    this.refreshModal.emit(true);
  }

  // 编辑订单金额
  @WritePermissionGurd("reservation_list")
  onModifyOrderFee() {
    if (this.checkIsEditing()) {
      return;
    }
    this.isEditingFee = true;
  }

  cancelEditOrderAmount() {
    this.isEditingFee = false;
  }

  onLockOrder() {
    this.displayLockOrderTip();
  }

  private displayLockOrderTip() {
    this.modal.confirm({
      // nzTitle: '是否锁定订单？',
      nzTitle: this.t.t("reservation.detail.lock_order.modal.title"),
      // nzContent: '锁定此订单可避免系统自动同步时覆盖已修改的内容。重新读取此订单即可解除锁定。',
      nzContent: this.t.t("reservation.detail.lock_order.modal.content"),
      nzOnOk: () => this.requestLockOrder(),
    });
  }

  private requestLockOrder() {
    this.orderService.lockOrder({ reservation_code: this.orderDetail.code }).subscribe((res) => {
      if (res.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }

  checkIsEditing() {
    if (this.isEditing) {
      this.msg.warning(this.t.t("errorText.order.cannot_edit_module"));
      return true;
    }
    return false;
  }

  /**
   * @params status 要变更的状态
   * @params isBulk 是否是批量修改
   */
  private requestUpdateCheckStatus(status, isBulk?) {
    const params = { to_status: status };

    if (isBulk) {
      Object.assign(params, { reservation_order_code: this.orderDetail.reservation_order.code });
    } else {
      Object.assign(params, { reservation_code: this.orderDetail.code });
    }

    this.orderService.handleStayingStatus(params).subscribe((res) => {
      if (res.error_code === 0) {
        // this.refresh = true;
        this.refreshModal.emit(true);
      }
    });
  }

  // 更新入住状态
  onUpdateCheckStatus(isBulk = false) {
    if (this.orderStatus === "wait_stay") {
      this.modal.warning({
        nzTitle: this.t.t("warning.order.confirm_check_in"),
        nzContent: this.t.t("warning.order.confirm_tenant_in"),
        nzOnOk: () => {
          this.requestUpdateCheckStatus("staying_checkin", isBulk);
        },
        nzCancelText: this.t.t("word.cancel"),
        nzOkText: this.t.t("word.confirm"),
      });
    } else if (this.orderStatus === "staying") {
      this.modal.warning({
        nzTitle: this.t.t("warning.order.confirm_check_out"),
        nzContent: this.t.t("warning.order.confirm_tenant_out"),
        nzOnOk: () => {
          this.requestUpdateCheckStatus("staying_checkout", isBulk);
        },
        nzCancelText: this.t.t("word.cancel"),
        nzOkText: this.t.t("word.confirm"),
      });
    }
  }

  // 撤销修改的入住状态
  onRevokeCheckStatus() {
    if (this.orderStatus === "staying") {
      this.modal.warning({
        // 确定撤销入住吗？订单将变为待入住状态。
        nzContent: this.t.t("warning.order.confirm_cancel_check_in"),
        nzOnOk: () => this.requestUpdateCheckStatus("staying_wait"),
        nzCancelText: this.t.t("word.cancel"),
      });
    } else if (this.orderStatus === "completed") {
      this.modal.warning({
        // 确定撤销退房吗？订单将变为入住中状态。
        nzContent: this.t.t("warning.order.confirm_cancel_check_out"),
        nzOnOk: () => this.requestUpdateCheckStatus("staying_checkin"),
        nzCancelText: this.t.t("word.cancel"),
      });
    }
  }
  @WritePermissionGurd("reservation_list")
  onExtendStay(isBatch = false) {
    const modalInstance = this.modal.create({
      nzTitle: this.t.t(isBatch ? "order.multi_continue_stay" : "order.continue_stay"),
      nzContent: ContinueStayComponent,
      nzFooter: null,
      nzWidth: 390,
      nzComponentParams: {
        reservation_code: isBatch ? this.orderDetail.reservation_order.code : this.orderDetail.code,
        type: isBatch ? "mass" : "single",
      },
      nzData: {
        reservation_code: isBatch ? this.orderDetail.reservation_order.code : this.orderDetail.code,
        type: isBatch ? "mass" : "single",
      },
    });
    modalInstance.afterClose.subscribe((res) => {
      if (res && res.refresh === true) {
        // this.refresh = true;
        this.refreshModal.emit(true);
      }
    });
  }

  @WritePermissionGurd("reservation_list")
  onClickCancelOrder() {
    if (this.orderDetail.is_hour_reservation) {
      this.requestCancelOrder();
    } else {
      const isBs = this.orderDetail.thirdparty_type === PlatformType.Bookingsite;
      const content = isBs
        ? this.t.t("warning.order.cancel_order_info_bs")
        : this.t.t("warning.order.cancel_order_info");
      this.modal.warning({
        nzTitle: this.t.t("warning.order.confirm_cancel_order"),
        nzContent: content,
        nzWidth: 600,
        nzOnOk: () => this.requestCancelOrder(),
        nzCancelText: this.t.t("word.no"),
        nzOkText: this.t.t("word.yes"),
      });
    }
  }

  requestCancelOrder() {
    const params = {
      reservation_code: this.orderDetail.code,
    };
    this.orderService.deleteHandmadeOrder(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.calendarService.removeReservation(this.orderDetail.code);
        const successText = this.t.t("success.order.cancel_order");
        this.msg.success(successText);
        if (this.pageType === "sidebar") {
          this.calendarService.cancelSelectReservation();
          this.calendarService.refresh();
        } else {
          // this.refresh = true;
          this.refreshModal.emit(true);
        }
      }
    });
  }

  @WritePermissionGurd("reservation_list")
  onAcceptOrder() {
    this.acceptLoading = true;
    const params = {
      reservation_code: this.orderDetail.code,
    };
    this.orderService.approveReservation(params).subscribe((res) => {
      this.acceptLoading = false;
      if (res.error_code === 0) {
        // this.refresh = true;
        this.refreshModal.emit(true);
        const successText = this.t.t("success.order.accept_order");
        this.msg.success(successText);

        this.globalModalService.displayTujiaAutoReceiptModal(this.orderDetail.code);
      } else {
        const warningText = this.t.t("warning.order.accept_order_failed");
        this.msg.warning(warningText);
      }
    });
  }

  @WritePermissionGurd("reservation_list")
  onRejectOrder() {
    this.refuseLoading = true;
    const params = {
      reservation_code: this.orderDetail.code,
    };
    this.orderService.declineReservation(params).subscribe((res) => {
      this.refuseLoading = false;
      if (res.error_code === 0) {
        // this.refresh = true;
        this.refreshModal.emit(true);
        const successText = this.t.t("success.order.refuse_order");
        this.msg.success(successText);
      } else {
        const warningText = this.t.t("warning.order.refuse_order_failed");
        this.msg.warning(warningText);
      }
    });
  }

  close() {
    this.calendarService.cancelSelectReservation();
    this.drawerRef?.close();
  }

  // toLog(type: "reservation" | "reservation_order", code: string) {
  //   this.modal.closeAll();
  //   this.router.navigate(["/app/system"], {
  //     queryParams: {
  //       tab: 1,
  //       logType: type,
  //       code: code
  //     }
  //   });
  // }

  onModifyLockPW() {
    this.isEditingLockPwd = false;
    this.refreshModal.emit(true);
  }

  onClickConflictLink() {
    const conflictIds = this.orderDetail.conflict_label.conflict_ids;
    window.open("/app/reservations?conflict_ids=" + conflictIds.join(","));
  }

  toggleHourCalendarCollapse() {
    this.hourCalendarCollapsed = !this.hourCalendarCollapsed;
    this.storeService.set("collapse_hour_calendar_in_order_detail", this.hourCalendarCollapsed, 2);
  }

  toHourDetail(code) {
    if (this.pageType === "sidebar") {
      this.calendarService.selectReservation(code);
      return;
    } else {
      if (!this.orderDetail.is_hour_reservation) {
        this.modal.create({
          nzTitle: this.t.t("word.order_detail"),
          nzContent: HouseOrderDetailComponent,
          nzFooter: null,
          nzWidth: 900,
          nzComponentParams: {
            code: code,
            pageType: "modal",
          },
        });
      } else {
        this.changeOrder.emit({ code: code });
      }
    }
  }

  onClickCreateHourOrder(date) {
    this.calendarService.cancelSelectReservation();
    // this.switchPageService.destroyCurrentLianBiao();
    const params = {
      house: {
        id: this.orderDetail.house_id,
        house_title: this.orderDetail.house_title,
      },
      date: date,
    };
    this.calendarService.displayHourReservationSidebar(params);
    //
    //
    //
    // 以上逻辑之后废弃，由drawerRef主动订阅该事件
    this.onCreateHourOrder.emit(params);
  }
}
